export default __webpack_public_path__ + "static/media/pig.074f7e03.svg";